import * as React from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import { observer, inject } from 'mobx-react'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import ErrorIcon from '@material-ui/icons/Error'
import InfoIcon from '@material-ui/icons/Info'
import WarningIcon from '@material-ui/icons/Warning'
import { SnackbarContent } from '@material-ui/core'
import classNames from 'classnames'
import { SnackbarStore } from '../../stores/snackbar-store'

const styles = require('./snackbar-manager.module.scss')

export interface SnackbarManagerProps {
    snackbarStore?: SnackbarStore
}

const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
}

@inject(SnackbarStore.storeName)
@observer
export class SnackbarManager extends React.Component<SnackbarManagerProps> {
    render() {
        const {snack, close} = this.props.snackbarStore
        const {open, origin, message, duration, actions, showCloseIcon, variant } = snack

        if (variant) {
            const Icon = variantIcon[variant]

            return (
                <Snackbar
                    id="snackbar"
                    anchorOrigin={origin}
                    open={open}
                    autoHideDuration={duration}
                    onClose={close}
                    className={styles.variantSnackBar}
                >
                    <SnackbarContent
                        id="snackbar"
                        className={styles[variant]}
                        aria-describedby="client-snackbar"
                        message={
                            <span id="client-snackbar" className={styles.message}>
                        <Icon className={classNames(styles.icon, styles.iconVariant)} />
                                {message}
                    </span>
                        }
                        action={[
                            <IconButton key="close" aria-label="close" color="inherit" onClick={close}>
                                <CloseIcon className={styles.icon} />
                            </IconButton>,
                        ]}
                    />
                </Snackbar>
            )
        }
        return (
            <Snackbar
                id="snackbar"
                anchorOrigin={origin}
                open={open}
                autoHideDuration={duration}
                onClose={close}
                message={<span id="message-id">{message}</span>}
                action={[
                    ...actions,
                    showCloseIcon ?
                        <IconButton
                            key="close"
                            aria-label="Close"
                            color="inherit"
                            onClick={close}
                        >
                            <CloseIcon />
                        </IconButton> :
                        null
                ]}
            />
        )
    }
}
